import { createActionConst } from '../../../../utils/action.utils';

const PERSONAL_NOTES_NAMESPACE = 'PERSONAL_NOTES';

export const SETUP_PERSONAL_NOTES = createActionConst(PERSONAL_NOTES_NAMESPACE, 'SETUP_PERSONAL_NOTES');
export const CREATE_PERSONAL_NOTE = createActionConst(PERSONAL_NOTES_NAMESPACE, 'CREATE_PERSONAL_NOTE');
export const UPDATE_PERSONAL_NOTE = createActionConst(PERSONAL_NOTES_NAMESPACE, 'UPDATE_PERSONAL_NOTE');
export const DELETE_PERSONAL_NOTE = createActionConst(PERSONAL_NOTES_NAMESPACE, 'DELETE_PERSONAL_NOTE');

export const STORE_PERSONAL_NOTES = createActionConst(PERSONAL_NOTES_NAMESPACE, 'STORE_PERSONAL_NOTES');
export const CLEAR_PERSONAL_NOTES = createActionConst(PERSONAL_NOTES_NAMESPACE, 'CLEAR_PERSONAL_NOTES');
